import {
  ClearIcon,
  FontSizeEnum,
  FontWeightEnum,
  HTMLElementTypeEnum,
  IconSizeEnum,
  Panel,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { REVIEW_STATES, TReviewStates } from '@/constants';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';

import { MentionShowSelectedFilter } from './components/MentionShowSelectedFilter';
import { hasAppliedFilters } from './hooks/has-applied-filters';
import { useMentionShowSelectedFiltersState } from './hooks/useMentionShowSelectedFiltersState';

type TMonitoringShowSelectedFiltersProps = {
  isVerticalStyle?: boolean;
  reviewStateOptions?: TReviewStates[];
};

export function MentionShowSelectedFilters(props: TMonitoringShowSelectedFiltersProps) {
  const applied = useProgramBroadcastFilters(hasAppliedFilters);

  if (!applied) {
    return null;
  }

  return <AppliedFiltersSummary {...props} />;
}

function AppliedFiltersSummary({
  isVerticalStyle = false,
  reviewStateOptions = REVIEW_STATES,
}: TMonitoringShowSelectedFiltersProps) {
  const { t } = useTranslation();
  const { selectedFilters, onCleanFilters } = useMentionShowSelectedFiltersState({
    reviewStateOptions,
  });

  return (
    <Panel
      isOpen={true}
      className={clsx(
        'mt-size-4 flex w-full flex-wrap gap-size-8 bg-opacity-alert/5 px-1 lg:flex-nowrap',
        {
          'flex-col': isVerticalStyle,
          'flex-row': !isVerticalStyle,
        }
      )}
    >
      <Typography
        className={clsx('flex items-center whitespace-nowrap')}
        fontSize={FontSizeEnum.Basic}
        weight={FontWeightEnum.Semibold}
        element={HTMLElementTypeEnum.Span}
      >
        {t('Filtros aplicados:')}
      </Typography>

      {selectedFilters.map(({ icon, items }, index) => (
        <MentionShowSelectedFilter
          key={index}
          icon={icon}
          classIcon={
            'text-accent-active-primary-40 group-hover:text-accent-active-primary-40 text-text-dark-10'
          }
          items={items.filter((item): item is string => typeof item === 'string')}
        />
      ))}
      <ClearIcon
        size={IconSizeEnum.SM}
        className={'flex-items cursor-pointer text-accent-active-primary-40'}
        onClick={onCleanFilters}
      />
    </Panel>
  );
}
